import React from 'react';

const UserMenuIcon = React.forwardRef<any, any>(({ children, onClick }, ref) => (
    <span ref={ref} onClick={onClick} className="user-menu__icon" />
));

export default UserMenuIcon;